// client/src/pages/OrganiserRequest.js
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiFetch } from '../lib/api';

export default function OrganiserRequest() {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const user = useMemo(() => {
    try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; }
  }, []);

  const handleRequest = async () => {
    try {
      setSubmitting(true);
      const res = await apiFetch('/api/groups/organiser/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ /* server only needs token; keep empty or add notes */ }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data?.error || 'Failed to submit organiser request');
      alert('Request submitted. A superadmin will review and approve.');
      navigate('/groups');
    } catch (e) {
      alert(e.message || 'Failed to submit organiser request');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="main-content">
      <h2 className="page-title">Request Organiser Approval</h2>
      <p>Once approved by a superadmin, you can create new groups.</p>
      <button onClick={handleRequest} disabled={submitting}>
        {submitting ? 'Submitting…' : 'Submit Request'}
      </button>
      <div style={{ marginTop: 16 }}>
        <button onClick={() => navigate('/groups')}>Back to Groups</button>
      </div>
    </div>
  );
}
